export const formatOrganisationNumber = (
  organisationNumber: string
): string => {
  return organisationNumber
    .replace(/[^0-9]/g, '')
    .replace(/(\d{6})(\d+)/, '$1-$2')
}
